import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.313 12a7.312 7.312 0 1 0-14.625 0 7.312 7.312 0 0 0 14.625 0M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0m5.97-3.189A1.97 1.97 0 0 1 10.826 7.5h2.05a2.218 2.218 0 0 1 1.103 4.145l-1.135.65a.846.846 0 0 1-.844.83.84.84 0 0 1-.844-.844v-.474c0-.303.162-.58.426-.732l1.557-.893a.532.532 0 0 0-.264-.991h-2.05a.28.28 0 0 0-.263.186l-.014.043a.844.844 0 0 1-1.589-.563l.014-.042zm1.905 6.564a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0"
    }, null, -1)
  ]))]))
}
export default { render: render }